import React from 'react';
import './Brokerage.css';

// Cash-Detail-Dialog (Chat vom 2026-08-08, Nutzerwunsch: "Gesamtsumme in
// Euro, über ein Icon dann die Detailpositionen je Währung in einem
// Dialog") - reiner Anzeige-Dialog, kein Formular, deshalb bewusst nicht
// nach dem Muster von IbBrokerageOrderForm.js (kein Bestaetigungs-/
// Sende-Schritt), sondern einfache Liste in derselben .brokerage-overlay/
// .brokerage-card-Optik.
// props: x, balances ([{currency, cashbalance, valueeur}]), totalEur, onClose().
export default function IbBrokerageCashDialog(props) {
	const balances = props.balances || [];

	function formatAmount(value) {
		if (value === undefined || value === null || value === '') return '–';
		const parsed = parseFloat(value);
		return Number.isNaN(parsed) ? '–' : parsed.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}

	return (
		<div className="brokerage-card">
			<i className="bi bi-x-lg brokerage-card-close" title="Schließen" onClick={props.onClose}></i>
			<h4>Cashbestand je Währung</h4>
			{balances.length === 0 && <p className="brokerage-hint">Keine Cash-Daten vorhanden.</p>}
			{balances.length > 0 &&
				<div className="brokerage-cash-list">
					<div className="brokerage-cash-row brokerage-cash-row-header">
						<span>Währung</span>
						<span>Bestand</span>
						<span>≈ EUR</span>
					</div>
					{balances.map((b) => (
						<div className="brokerage-cash-row" key={b.currency}>
							<span>{b.currency}</span>
							<span>{formatAmount(b.cashbalance)}</span>
							<span>{b.valueeur !== undefined ? formatAmount(b.valueeur) : '–'}</span>
						</div>
					))}
					<div className="brokerage-cash-row brokerage-cash-row-total">
						<span>Summe</span>
						<span></span>
						<span>{formatAmount(props.totalEur)}</span>
					</div>
				</div>
			}
		</div>
	);
}
